(function(){
function init(root){
if(root.dataset.pvDesignerBriefReady)return;
root.dataset.pvDesignerBriefReady='1';
var services=root.querySelector('.pv-order__services');
var first=root.querySelector('[data-pv-design-service]');
var formId=first&&first.getAttribute('form');
if(!services||!formId)return;
var nl=location.pathname.indexOf('/nl/')===0||/^nl/i.test(document.documentElement.lang||'');
var block=document.createElement('div');
block.className='pv-order__designer-brief';
block.setAttribute('data-pv-designer-brief','');
block.hidden=true;
block.innerHTML='<label class="pv-order__label">'+(nl?'Designer instructies':'Designer instructions')+'</label><textarea name="properties[Designer instructies]" placeholder="'+(nl?'Logo-positie, tekst, kleuren, deadline, voorbeelden.':'Logo position, copy, colours, deadline, examples.')+'" disabled></textarea><span class="pv-order__small">'+(nl?'Upload extra logo\'s, huisstijl of voorbeelden.':'Upload extra logos, brand files or examples.')+'</span><div class="pv-order__designer-files"><input type="file" name="properties[Extra bestand 1]" disabled><input type="file" name="properties[Extra bestand 2]" disabled></div>';
block.querySelectorAll('textarea,input').forEach(function(el){el.setAttribute('form',formId);});
services.appendChild(block);
function sync(){
var checked=root.querySelector('[data-pv-design-service]:checked');
var label=String((checked&&(checked.getAttribute('data-label')||checked.value))||'').toLowerCase();
var show=label.indexOf('laat je ontwerp maken of aanpassen')!==-1||label.indexOf('have your design created or adjusted')!==-1||label.indexOf('make or edit your design')!==-1||label.indexOf('design made or adjusted')!==-1;
block.hidden=!show;
block.querySelectorAll('textarea,input').forEach(function(el){el.disabled=!show;});
}
root.querySelectorAll('[data-pv-design-service]').forEach(function(input){input.addEventListener('change',sync);});
sync();
}
function boot(){document.querySelectorAll('.promo-vista-order-configurator').forEach(init);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();